/* Evolved Elements product landing page: swipeable hero gallery + bottle video. */
(function () {
  'use strict';
  var CDN = 'https://cdn.shopify.com/s/files/1/0799/4857/9091/files/';
  var VIDEO = 'https://cdn.shopify.com/videos/c/vp/27799231a8ab474193dc328aba061816/27799231a8ab474193dc328aba061816.SD-480p-1.0Mbps-95374843.mp4';
  var MAP = {
    '01-packshot': 'ee-lp-hero-bottle.jpg', '01f-film': 'ee-lp-seqw-f000.webp', '02-labs': 'ee-lp-four-labs.jpg',
    '03-capsule': 'ee-lp-capsule-v2.jpg', '04-origin': 'ee-lp-sourcing-origin.jpg', '05-feedlot': 'ee-lp-nz-vs-feedlot.jpg',
    '06-pathway': 'ee-lp-metabolic-pathway.jpg', '07-guarantee': 'ee-lp-guarantee-delivery.jpg'
  };
  // Shopify's image CDN resizes and serves WebP/AVIF automatically when a width is requested.
  window.EE_IMG = function (key, w) { return CDN + (MAP[key] || MAP['01-packshot']) + '?width=' + (w || 900); };

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = 0, raf = 0, video, playBtn, io;
  // The page runtime re-renders the hero, so every lookup is live instead of cached.
  function T() { return document.querySelector('.ee-gal-track'); }
  function S() { var t = T(); return t ? t.querySelectorAll('.ee-gal-slide') : []; }
  function tabs() { return document.querySelectorAll('[role=tablist][aria-label="Product images"] [role=tab]'); }

  window.EE_GAL = {
    go: function (i) {
      var t = T(); if (!t || window.EE_GAL._fromSwipe) return;
      i = Math.max(0, Math.min(S().length - 1, i));
      cur = i; film();
      var c = document.querySelector('.ee-gal-count'); if (c) c.textContent = (i + 1) + ' / ' + S().length;
      var x = i * t.clientWidth;
      if (reduce || document.hidden) { t.scrollTo({ left: x, behavior: 'instant' }); return; }
      t.scrollTo({ left: x, behavior: 'smooth' });
      // Some browsers drop smooth scrolls inside snap containers; land on the slide regardless.
      setTimeout(function () { var u = T(); if (u && Math.abs(u.scrollLeft - x) > 4) u.scrollTo({ left: x, behavior: 'instant' }); }, 700);
    },
    step: function (d) { window.EE_GAL.go(cur + d); }
  };

  function sync() {
    raf = 0;
    var t = T(); if (!t) return;
    var n = S().length, i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
    var c = document.querySelector('.ee-gal-count'); if (c) c.textContent = (i + 1) + ' / ' + n;
    if (i === cur) return;
    cur = i;
    var tb = tabs()[i];
    if (tb && tb.getAttribute('aria-selected') !== 'true') { window.EE_GAL._fromSwipe = true; tb.click(); window.EE_GAL._fromSwipe = false; }
    film();
  }

  function mountVideo() {
    var slot = document.querySelector('.ee-film-slot');
    if (!slot) return;
    if (video && slot.contains(video)) return;
    if (!video) {
      video = document.createElement('video');
      video.muted = true; video.defaultMuted = true; video.loop = true; video.playsInline = true;
      video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
      video.preload = 'none';
      video.poster = window.EE_IMG('01f-film', 900);
      video.setAttribute('aria-label', 'Evolved Elements Thyroid Glandular bottle, turning');
      video.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;background:#F0EAE0';
      playBtn = document.createElement('button');
      playBtn.type = 'button'; playBtn.className = 'ee-gal-play'; playBtn.setAttribute('aria-label', 'Play video');
      playBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
      playBtn.hidden = true;
      playBtn.addEventListener('click', function (e) { e.stopPropagation(); play(true); });
      video.addEventListener('click', function () { if (video.paused) play(true); else { video.pause(); playBtn.hidden = false; } });
    }
    slot.appendChild(video); slot.appendChild(playBtn);
    if ('IntersectionObserver' in window) {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.intersectionRatio > 0.55) play(); else pause(); }); }, { threshold: [0, 0.55, 1] });
      io.observe(slot);
    }
  }
  function play(user) {
    if (!video) return;
    if (!video.getAttribute('src')) { video.src = VIDEO; video.preload = 'auto'; }
    if (reduce && !user) { playBtn.hidden = false; return; }
    var p = video.play();
    if (p && p.then) p.then(function () { playBtn.hidden = true; }).catch(function () { playBtn.hidden = false; });
  }
  function pause() { if (video && !video.paused) video.pause(); }
  function film() { var s = S()[cur]; if (s && s.querySelector('.ee-film-slot')) play(); else pause(); }

  // Delegated listeners survive re-renders.
  var settle = 0;
  document.addEventListener('scroll', function (e) {
    if (!(e.target && e.target.classList && e.target.classList.contains('ee-gal-track'))) return;
    clearTimeout(settle); settle = setTimeout(sync, 140);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ee-gal-prev,.ee-gal-next'); if (!b) return;
    window.EE_GAL.step(b.classList.contains('ee-gal-next') ? 1 : -1);
  });
  document.addEventListener('keydown', function (e) {
    if (!e.target.classList || !e.target.classList.contains('ee-gal-track')) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); window.EE_GAL.step(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); window.EE_GAL.step(-1); }
  });
  window.addEventListener('resize', function () { var t = T(); if (t) t.scrollTo({ left: cur * t.clientWidth, behavior: 'instant' }); });
  // Re-attach the video if the runtime replaces the slot; download starts only when the slide is on screen.

  // Warm every slide once the gallery is close to the screen, so swiping never shows a blank frame.
  function warm(sel) {
    var g = document.querySelector(sel); if (!g || g.__warm) return; g.__warm = 1;
    var go = function () { g.querySelectorAll('img[loading=lazy]').forEach(function (i) { i.loading = 'eager'; }); };
    if (!('IntersectionObserver' in window)) return go();
    var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { o.disconnect(); go(); } }, { rootMargin: '600px 0px' });
    o.observe(g);
  }
  function watch() {
    if (!T()) return setTimeout(watch, 250);
    setTimeout(function () { warm('.ee-gal'); }, 2500);
    var c = document.querySelector('.ee-gal-count'); if (c) c.textContent = '1 / ' + S().length;
    var kick = function () { mountVideo(); new MutationObserver(function () { mountVideo(); }).observe(T().parentNode.parentNode, { childList: true, subtree: true }); };
    if ('requestIdleCallback' in window) requestIdleCallback(kick, { timeout: 2500 }); else setTimeout(kick, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
